<ngx-spinner bdColor="rgba(0,0,0,0)"
             size="medium"
             color="#000000"
             type="ball-spin-clockwise">
</ngx-spinner>
<div class="modal-signup modal-content" *ngIf="ModalType=='OldStore'">
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header padding-bottom-5px border-bottom-1px padding-top-6px padding-left-10px padding-right-10px">

        <div class="row">
          <div class="col-md-1 padding-right-0px padding-left-6px" *ngIf="ActorCodeDetails">
            <img class="img-circle-56 margin-left-10px" [src]="ActorCodeDetails.EggPatientImageFile" onError="this.src='dummy.jpg';">
          </div>
          <div class="col-md-2 line-height-17px  padding-right-0px" *ngIf="ActorCodeDetails">
            <label class="margin-bottom-0px color5 font-weight-bold font-size-16px margin-bottom-0px">{{ActorCodeDetails.EggName}}</label>
            <div><label class="margin-bottom-0px font-size-14 font-weight-normal">{{ActorCodeDetails.EggFormattedCode}}</label>,<label *ngIf="ActorCodeDetails" class="margin-bottom-0px font-size-14 font-weight-normal">{{ActorCodeDetails.EggAgeYears}}</label></div>
            <div><label class="margin-bottom-0px font-size-14 font-weight-normal">{{ActorCodeDetails.EggTelephone1}}</label></div>
          </div>
          <!--<div class="col-md-3" *ngIf="PatientDetails">

          </div>-->

          <div class="col-md-9 ">
            <button type="button" class="close float-right" data-dismiss="modal"
                    (click)="activeModal.dismiss('Cross click')"
                    aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
            <!--<button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3  font-size-15px float-right margin-left-5px" (click)="activeModal.close('Close click')">Close</button>
            <button (click)="onSubmit()" [disabled]="!f.valid" class="btn actions-btn-prime float-right font-size-15px ">Save</button>-->
          </div>
        </div>
        <!--{{ sectionData.Title }}-->


      </div>
      <div class="card-body padding-bottom-0px padding-right-0px margin-left-0px padding-top-0px padding-left-0px">
        <div class="row border-top border-bottom bk-color-light margin-left-zero margin-right-0px">
          <div class="col-md-3  text-align-center padding-right-0px padding-left-0px border-right-1px">
            <div class="margin-top-10"><h4 class=" font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">Cycle</h4></div>
            <div class="margin-bottom-10px"><h4 class="margin-bottom-0px"></h4></div>
          </div>
          <div class="col-md-3  text-align-center padding-right-0px padding-left-0px border-right-1px">
            <div class="margin-top-10"><h4 class="font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">Day</h4></div>
            <div class="margin-bottom-10px"><h4 class="margin-bottom-0px" *ngIf="Day">{{Day}}</h4></div>
          </div>
          <div class="col-md-3 text-align-center padding-right-0px padding-left-0px border-right-1px">
            <div class="margin-top-10"><h4 class=" font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">Grade</h4></div>
            <div class="margin-bottom-10px"><h4 class="margin-bottom-0px display-inline" *ngIf="Grade1">{{Grade1}}</h4><h4 class="margin-bottom-0px display-inline" *ngIf="Grade2">{{Grade2}}</h4> </div>
          </div>
          <div class="col-md-3 text-align-center padding-right-0px padding-left-0px border-right-1px">
            <div class="margin-top-10"><h4 class=" font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">EmbryoCount</h4></div>
            <div class="margin-bottom-10px"><h4 class="margin-bottom-0px" *ngIf="Embryocount">{{Embryocount}}</h4></div>
          </div>
        </div>
        <div class="row margin-left-zero margin-right-0px" *ngIf="Listview">
          <div class="card col-md-12">
            <div class="card-header wh-header padding-top-6px padding-bottom-6px">
              <div class="row">
                <div class="col-md-8">
                  <label class="margin-bottom-0px">Embryo Store Locations</label>
                </div>
                <div class="col-md-4">
                  <button type="button" (click)="AddEmbryostore()"
                          class="btn  btn-sm drive-button3 background-primary border-all-secondary float-right" id="FileUpload"
                          name="upload " title="Click Here To Add New Row">
                    <i class="fas fa-plus font-size-11"></i>
                  </button>
                </div>
              </div>

            </div>
            <div class="card-body padding-all-0px margin-left-zero">
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-md-12">
                  <div class="table-component margin-bottom-0px">
                    <div class="table-responsive">


                      <table class="table table-striped margin-left-zero">
                        <thead class="">
                          <tr>
                            <th class="padding-top-4px padding-bottom-4px font-size-12px min-width-0px">Count</th>
                            <!--<th class="padding-top-4px padding-bottom-4px td-well-width-79px font-size-12px" *ngIf="DOC=='5' || DOC=='6'">Blastomere Count</th>-->
                            <th class="padding-top-4px padding-bottom-4px  font-size-12px padding-left-6px">Cryo Top</th>
                            <th class="padding-top-4px padding-bottom-4px font-size-12px padding-left-6px">Cannister</th>
                            <th class="padding-top-4px padding-bottom-4px font-size-12px padding-left-6px">Goblet</th>
                            <th class="padding-top-4px padding-bottom-4px font-size-12px padding-left-6px">Hexa</th>
                            <th class="padding-top-4px padding-bottom-4px font-size-12px padding-left-6px">Viso</th>


                            <th class="td-well-width-79px padding-top-4px padding-bottom-4px font-size-12px"></th>
                          </tr>
                        </thead>

                        <tbody class="table-body">
                          <tr *ngFor="let l of CurrentIvfCycleEmbryoStorageAreaController">
                            <td class="padding-top-0px padding-bottom-0px text-align-center padding-left-0px">
                              {{l.EmbryoCount}}
                            </td>
                            <td class="padding-top-0px padding-bottom-0px">
                              {{l.CryoTopColor}}
                            </td>

                            <td class="padding-top-0px padding-bottom-0px">
                              {{l.CanisterNo}}
                            </td>
                            <td class="padding-top-0px padding-bottom-0px ">

                              {{l.Goblet}}
                              <!--Day{{DOC}}Grade{{1}}-->
                              <!--<CodeTypeValue CodeType="InsTe"></CodeTypeValue>-->

                            </td>
                            <td class="padding-top-0px padding-bottom-0px ">




                              {{l.Hexa}}
                            </td>
                            <td class="padding-top-0px padding-bottom-0px ">
                              {{l.Viso}}
                            </td>


                            <td class="padding-all-0px">
                              <div class="test-icons">
                                <a (click)="EditEmbryoData(l)" class="font-size-16px color-Assign" title="Edit"><i class="fas fa-pencil-alt margin-left-10px margin-bottom-3px nav-link-hand"></i></a>
                                <a class="nav-link-hand font-size-20px margin-left-15px" title="Remove"><i class="fa fa-times color-Rejected nav-link-hand"></i></a>
                              </div>
                            </td>

                          </tr>

                        </tbody>
                        <tfoot>
                          <tr>
                            <td colspan="2">Total Stored: {{TotalValue}} of {{FrozenCount}}</td>

                          </tr>
                        </tfoot>
                      </table>

                    </div>
                  </div>
                </div>
              </div>

            </div>
            <div class="card-footer padding-top-6px padding-bottom-6px">
              <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px float-right" (click)="activeModal.close('Close click')">Close</button>

            </div>
          </div>
        </div>
        <div class="row margin-left-zero margin-right-0px" *ngIf="AddEmbryo">
          <div class="card col-md-12">
            <div class="card-header wh-header padding-top-6px padding-bottom-6px">
              <div class="row">
                <div class="col-md-8">
                  <label class="margin-bottom-0px">Add Embryos To Store</label>
                </div>

              </div>

            </div>
            <form class="form margin-bottom-5px" (ngSubmit)="onSubmit()" novalidate="" #f="ngForm">
              <div class="card-body padding-all-0px margin-left-zero">
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-md-12">
                    <div class="row">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                        <div class="row">
                          <div class="col-md-3 text-align-right">
                            <label for="diaplayName" class="margin-bottom-0px margin-top-3px"> Cryo Top Color</label>
                          </div>

                          <div class="col-md-4">
                            <CodeTypeValue CodeType="CRCLR" id="CurrentSaveEmbryoStorageAreaInfoRequest.CryoTopColor"
                                           [(ngModel)]="CurrentSaveEmbryoStorageAreaInfoRequest.CryoTopColor" SelectedValue=""
                                           name="CurrentSaveEmbryoStorageAreaInfoRequest.CryoTopColor">
                            </CodeTypeValue>
                            <!--<input type="text" class="form-control" placeholder="Relation Name" />-->
                            <!--id="CurrentActorEditEmergencyInfoRequest.RelationType"
                                   [(ngModel)]="CurrentActorEditEmergencyInfoRequest.RelationType"
                                   name="CurrentActorEditEmergencyInfoRequest.RelationType"
                                    maxlength="20" minlength="1" #RelationType="ngModel" pattern="^[\sa-zA-Z0-9,/._\-?]*$">
                            <small class="form-text text-danger"
                                   *ngIf="(!RelationType.valid && (RelationType.dirty || RelationType.touched) && RelationType.errors.required)">(Field cannot be left blank)</small>
                            <small class="form-text text-danger"
                                   *ngIf="(!RelationType.valid && RelationType.errors.pattern)">(special characters are not allowed)</small>-->

                          </div>
                        </div>


                      </div>
                    </div>
                    <div class="row">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                        <div class="row">
                          <div class="col-md-3 text-align-right">
                            <label for="firstName" class="margin-bottom-0px margin-top-3px"> Cannister No</label>
                          </div>
                          <div class="col-md-4">

                            <CodeTypeValue CodeType="CNSTR"
                                           id="CurrentSaveEmbryoStorageAreaInfoRequest.CanisterNo"
                                           [(ngModel)]="CurrentSaveEmbryoStorageAreaInfoRequest.CanisterNo" SelectedValue=""
                                           name="CurrentSaveEmbryoStorageAreaInfoRequest.CanisterNo">
                            </CodeTypeValue>

                          </div>

                        </div>

                      </div>
                    </div>
                    <div class="row">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                        <div class="row">
                          <div class="col-md-3 text-align-right padding-left-0px">
                            <label for="diaplayName" class="margin-bottom-0px margin-top-3px"> Goblet</label>
                          </div>
                          <div class="col-md-4">
                            <CodeTypeValue CodeType="GBCLR"
                                           id="CurrentSaveEmbryoStorageAreaInfoRequest.Goblet"
                                           [(ngModel)]="CurrentSaveEmbryoStorageAreaInfoRequest.Goblet" SelectedValue=""
                                           name="CurrentSaveEmbryoStorageAreaInfoRequest.Goblet">
                            </CodeTypeValue>
                          </div>
                        </div>


                      </div>
                    </div>
                    <div class="row">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                        <div class="row">
                          <div class="col-md-3 text-align-right ">
                            <label for="diaplayName" class="margin-bottom-0px margin-top-3px">Hexa </label>
                          </div>
                          <div class="col-md-4 ">
                            <!--<CodeTypeValue CodeType="MARTL"></CodeTypeValue>-->
                            <!--id="CurrentActorPersonalDetailInfoRequest.City"
                                   [(ngModel)]="CurrentActorPersonalDetailInfoRequest.City"
                                   name="CurrentActorPersonalDetailInfoRequest.City"
                                    maxlength="50" pattern="^[\sa-zA-Z0-9,._\-?]*$" #City="ngModel" />
                            <small class="form-text text-danger"
                                   *ngIf="(!City.valid && City.errors.pattern)">(special characters are not allowed)</small>-->
                            <!--<label>Hyderabad</label>-->
                            <CodeTypeValue CodeType="HXCLR"
                                           id="CurrentSaveEmbryoStorageAreaInfoRequest.Hexa"
                                           [(ngModel)]="CurrentSaveEmbryoStorageAreaInfoRequest.Hexa" SelectedValue=""
                                           name="CurrentSaveEmbryoStorageAreaInfoRequest.Hexa">
                            </CodeTypeValue>
                          </div>
                        </div>


                      </div>
                    </div>
                    <div class="row">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                        <div class="row">
                          <div class="col-md-3 text-align-right ">
                            <label for="diaplayName" class="margin-bottom-0px margin-top-3px">Viso </label>
                          </div>
                          <div class="col-md-4 ">
                            <!--<CodeTypeValue CodeType="MARTL"></CodeTypeValue>-->
                            <!--id="CurrentActorPersonalDetailInfoRequest.City"
                                   [(ngModel)]="CurrentActorPersonalDetailInfoRequest.City"
                                   name="CurrentActorPersonalDetailInfoRequest.City"
                                    maxlength="50" pattern="^[\sa-zA-Z0-9,._\-?]*$" #City="ngModel" />
                            <small class="form-text text-danger"
                                   *ngIf="(!City.valid && City.errors.pattern)">(special characters are not allowed)</small>-->
                            <!--<label>Hyderabad</label>-->
                            <CodeTypeValue CodeType="VSCLR"
                                           id="CurrentSaveEmbryoStorageAreaInfoRequest.Viso"
                                           [(ngModel)]="CurrentSaveEmbryoStorageAreaInfoRequest.Viso" SelectedValue=""
                                           name="CurrentSaveEmbryoStorageAreaInfoRequest.Viso">
                            </CodeTypeValue>
                          </div>
                        </div>


                      </div>
                    </div>

                    <div class="row">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                        <div class="row">
                          <div class="col-md-3 text-align-right ">
                            <label for="diaplayName" class="margin-bottom-0px margin-top-3px">Count </label>
                          </div>
                          <div class="col-md-4 ">
                            <input type="text" class="form-control" placeholder="Count"
                                   id="CurrentSaveEmbryoStorageAreaInfoRequest.StoreEmbryoCount"
                                   [(ngModel)]="CurrentSaveEmbryoStorageAreaInfoRequest.StoreEmbryoCount"
                                   name="CurrentSaveEmbryoStorageAreaInfoRequest.StoreEmbryoCount" #Endometrium="ngModel"
                                   maxlength="5" pattern="^[\0-9,._\-?]*$" required>
                            <small class="form-text text-danger"
                                   *ngIf="(!Endometrium.valid && (Endometrium.dirty || Endometrium.touched) && Endometrium.errors.required )">(Field cannot be left blank)</small>
                            <small class="form-text text-danger"
                                   *ngIf="(!Endometrium.valid && Endometrium.errors.pattern)">(only numbers are allowed)</small>
                          </div>
                          <!--<div class="col-md-3" *ngIf="BeforeEnterInput">
                            <label>({{FrozenCount}} Remaining)</label>
                          </div>
                          <div class="col-md-3" *ngIf="AfterEnterInput">
                            <label>({{FrozenCount-CurrentSaveEmbryoStorageAreaInfoRequest.StoreEmbryoCount }} Remaining)</label>
                          </div>-->
                          <div class="col-md-3">
                            <label class="margin-bottom-0px margin-top-5px" *ngIf="TotalValue>0">({{FrozenCount-TotalValue}} Remaining)</label>
                            <label class="margin-bottom-0px margin-top-5px" *ngIf="!TotalValue && TotalValue!=0">({{FrozenCount }} Remaining)</label>
                          </div>
                        </div>


                      </div>
                    </div>
                  </div>
                </div>

              </div>
              <div class="card-footer padding-top-6px padding-bottom-6px">
                <button type="submit" class="btn actions-btn-prime float-right font-size-13px margin-right-auto margin-left-3px">Save</button>
                <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px float-right margin-left-3px" (click)="Back()">Cancel</button>



              </div>
            </form>
          </div>
        </div>
        <div class="row margin-left-zero margin-right-0px" *ngIf="EditEmbryo">
          <div class="card col-md-12">
            <div class="card-header wh-header padding-top-6px padding-bottom-6px">
              <div class="row">
                <div class="col-md-8">
                  <label class="margin-bottom-0px">Edit Embryos To Store</label>
                </div>

              </div>

            </div>
            <form class="form margin-bottom-5px" (ngSubmit)="OnEdditSubmit()" novalidate="" #f="ngForm">
              <div class="card-body padding-all-0px margin-left-zero">
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-md-12">
                    <div class="row">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                        <div class="row">
                          <div class="col-md-3 text-align-right">
                            <label for="diaplayName" class="margin-bottom-0px margin-top-3px"> Cryo Top Color</label>
                          </div>

                          <div class="col-md-4">
                            <CodeTypeValue CodeType="CRCLR" id="CurrentEditEmbryoStorageAreaInfoRequest.CryoTopColor"
                                           [(ngModel)]="CurrentEditEmbryoStorageAreaInfoRequest.CryoTopColor" SelectedValue="CurrentEditEmbryoStorageAreaInfoRequest.CryoTopColor"
                                           name="CurrentEditEmbryoStorageAreaInfoRequest.CryoTopColor">
                            </CodeTypeValue>
                            <!--<input type="text" class="form-control" placeholder="Relation Name" />-->
                            <!--id="CurrentActorEditEmergencyInfoRequest.RelationType"
                                   [(ngModel)]="CurrentActorEditEmergencyInfoRequest.RelationType"
                                   name="CurrentActorEditEmergencyInfoRequest.RelationType"
                                    maxlength="20" minlength="1" #RelationType="ngModel" pattern="^[\sa-zA-Z0-9,/._\-?]*$">
                            <small class="form-text text-danger"
                                   *ngIf="(!RelationType.valid && (RelationType.dirty || RelationType.touched) && RelationType.errors.required)">(Field cannot be left blank)</small>
                            <small class="form-text text-danger"
                                   *ngIf="(!RelationType.valid && RelationType.errors.pattern)">(special characters are not allowed)</small>-->

                          </div>
                        </div>


                      </div>
                    </div>
                    <div class="row">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                        <div class="row">
                          <div class="col-md-3 text-align-right">
                            <label for="firstName" class="margin-bottom-0px margin-top-3px"> Cannister No</label>
                          </div>
                          <div class="col-md-4">

                            <CodeTypeValue CodeType="CNSTR"
                                           id="CurrentEditEmbryoStorageAreaInfoRequest.CanisterNo"
                                           [(ngModel)]="CurrentEditEmbryoStorageAreaInfoRequest.CanisterNo" SelectedValue="CurrentEditEmbryoStorageAreaInfoRequest.CanisterNo"
                                           name="CurrentEditEmbryoStorageAreaInfoRequest.CanisterNo">
                            </CodeTypeValue>

                          </div>

                        </div>

                      </div>
                    </div>
                    <div class="row">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                        <div class="row">
                          <div class="col-md-3 text-align-right padding-left-0px">
                            <label for="diaplayName" class="margin-bottom-0px margin-top-3px"> Goblet</label>
                          </div>
                          <div class="col-md-4">
                            <CodeTypeValue CodeType="GBCLR"
                                           id="CurrentEditEmbryoStorageAreaInfoRequest.Goblet"
                                           [(ngModel)]="CurrentEditEmbryoStorageAreaInfoRequest.Goblet" SelectedValue="CurrentEditEmbryoStorageAreaInfoRequest.Goblet"
                                           name="CurrentEditEmbryoStorageAreaInfoRequest.Goblet">
                            </CodeTypeValue>
                          </div>
                        </div>


                      </div>
                    </div>
                    <div class="row">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                        <div class="row">
                          <div class="col-md-3 text-align-right ">
                            <label for="diaplayName" class="margin-bottom-0px margin-top-3px">Hexa </label>
                          </div>
                          <div class="col-md-4 ">
                            <!--<CodeTypeValue CodeType="MARTL"></CodeTypeValue>-->
                            <!--id="CurrentActorPersonalDetailInfoRequest.City"
                                   [(ngModel)]="CurrentActorPersonalDetailInfoRequest.City"
                                   name="CurrentActorPersonalDetailInfoRequest.City"
                                    maxlength="50" pattern="^[\sa-zA-Z0-9,._\-?]*$" #City="ngModel" />
                            <small class="form-text text-danger"
                                   *ngIf="(!City.valid && City.errors.pattern)">(special characters are not allowed)</small>-->
                            <!--<label>Hyderabad</label>-->
                            <CodeTypeValue CodeType="HXCLR"
                                           id="CurrentEditEmbryoStorageAreaInfoRequest.Hexa"
                                           [(ngModel)]="CurrentEditEmbryoStorageAreaInfoRequest.Hexa" SelectedValue="CurrentEditEmbryoStorageAreaInfoRequest.Hexa"
                                           name="CurrentEditEmbryoStorageAreaInfoRequest.Hexa">
                            </CodeTypeValue>
                          </div>
                        </div>


                      </div>
                    </div>
                    <div class="row">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                        <div class="row">
                          <div class="col-md-3 text-align-right ">
                            <label for="diaplayName" class="margin-bottom-0px margin-top-3px">Viso </label>
                          </div>
                          <div class="col-md-4 ">
                            <!--<CodeTypeValue CodeType="MARTL"></CodeTypeValue>-->
                            <!--id="CurrentActorPersonalDetailInfoRequest.City"
                                   [(ngModel)]="CurrentActorPersonalDetailInfoRequest.City"
                                   name="CurrentActorPersonalDetailInfoRequest.City"
                                    maxlength="50" pattern="^[\sa-zA-Z0-9,._\-?]*$" #City="ngModel" />
                            <small class="form-text text-danger"
                                   *ngIf="(!City.valid && City.errors.pattern)">(special characters are not allowed)</small>-->
                            <!--<label>Hyderabad</label>-->
                            <CodeTypeValue CodeType="VSCLR"
                                           id="CurrentEditEmbryoStorageAreaInfoRequest.Viso"
                                           [(ngModel)]="CurrentEditEmbryoStorageAreaInfoRequest.Viso" SelectedValue="CurrentEditEmbryoStorageAreaInfoRequest.Viso"
                                           name="CurrentEditEmbryoStorageAreaInfoRequest.Viso">
                            </CodeTypeValue>
                          </div>
                        </div>


                      </div>
                    </div>

                    <div class="row">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                        <div class="row">
                          <div class="col-md-3 text-align-right ">
                            <label for="diaplayName" class="margin-bottom-0px margin-top-3px">Count </label>
                          </div>
                          <div class="col-md-4 ">
                            <input type="text" class="form-control" placeholder="Count"
                                   id="CurrentEditEmbryoStorageAreaInfoRequest.StoreEmbryoCount"
                                   [(ngModel)]="CurrentEditEmbryoStorageAreaInfoRequest.StoreEmbryoCount"
                                   name="CurrentEditEmbryoStorageAreaInfoRequest.StoreEmbryoCount" #Endometrium="ngModel"
                                   maxlength="5" pattern="^[\0-9,._\-?]*$" required>
                            <small class="form-text text-danger"
                                   *ngIf="(!Endometrium.valid && (Endometrium.dirty || Endometrium.touched) && Endometrium.errors.required )">(Field cannot be left blank)</small>
                            <small class="form-text text-danger"
                                   *ngIf="(!Endometrium.valid && Endometrium.errors.pattern)">(only numbers are allowed)</small>
                          </div>
                          <!--<div class="col-md-3">
                            <label>(2 Remaining)</label>
                          </div>-->
                          <!--<div class="col-md-3" *ngIf="BeforeEnterInput">
                            <label>({{FrozenCount}} Remaining)</label>
                          </div>-->
                          <div class="col-md-3">
                            <label class="margin-bottom-0px margin-top-5px">({{FrozenCount-TotalValue }} Remaining)</label>
                          </div>
                        </div>


                      </div>
                    </div>
                  </div>
                </div>

              </div>
              <div class="card-footer padding-top-6px padding-bottom-6px">
                <button type="submit" class="btn actions-btn-prime float-right font-size-13px margin-right-auto margin-left-3px">Save</button>
                <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px float-right margin-left-3px" (click)="Back()">Cancel</button>



              </div>
            </form>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
<div class="modal-signup modal-content" *ngIf="ModalType=='NewStore'">
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header padding-bottom-5px border-bottom-1px padding-top-6px padding-left-10px padding-right-10px">

        <div class="row">
          <div class="col-md-1 padding-right-0px padding-left-6px" *ngIf="ActorCodeDetails">
            <img class="img-circle-56 margin-left-10px" [src]="ActorCodeDetails.EggPatientImageFile" onError="this.src='dummy.jpg';">
          </div>
          <div class="col-md-2 line-height-17px  padding-right-0px" *ngIf="ActorCodeDetails">
            <label class="margin-bottom-0px color5 font-weight-bold font-size-16px margin-bottom-0px">{{ActorCodeDetails.EggName}}</label>
            <div><label class="margin-bottom-0px font-size-14 font-weight-normal">{{ActorCodeDetails.EggFormattedCode}}</label>,<label *ngIf="ActorCodeDetails" class="margin-bottom-0px font-size-14 font-weight-normal">{{ActorCodeDetails.EggAgeYears}}</label></div>
            <div><label class="margin-bottom-0px font-size-14 font-weight-normal">{{ActorCodeDetails.EggTelephone1}}</label></div>
          </div>
          <!--<div class="col-md-3" *ngIf="PatientDetails">

          </div>-->

          <div class="col-md-9 ">
            <button type="button" class="close float-right" data-dismiss="modal"
                    (click)="activeModal.dismiss('Cross click')"
                    aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
            <!--<button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3  font-size-15px float-right margin-left-5px" (click)="activeModal.close('Close click')">Close</button>
            <button (click)="onSubmit()" [disabled]="!f.valid" class="btn actions-btn-prime float-right font-size-15px ">Save</button>-->
          </div>
        </div>
        <!--{{ sectionData.Title }}-->


      </div>
      <div class="card-body padding-bottom-0px padding-right-0px margin-left-0px padding-top-0px padding-left-0px">
        <!--<div class="row border-top border-bottom bk-color-light margin-left-zero margin-right-0px">
          <div class="col-md-3  text-align-center padding-right-0px padding-left-0px border-right-1px">
            <div class="margin-top-10"><h4 class=" font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">Cycle</h4></div>
            <div class="margin-bottom-10px"><h4 class="margin-bottom-0px"></h4></div>
          </div>
          <div class="col-md-3  text-align-center padding-right-0px padding-left-0px border-right-1px">
            <div class="margin-top-10"><h4 class="font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">Day</h4></div>
            <div class="margin-bottom-10px"><h4 class="margin-bottom-0px" *ngIf="Day">{{Day}}</h4></div>
          </div>
          <div class="col-md-3 text-align-center padding-right-0px padding-left-0px border-right-1px">
            <div class="margin-top-10"><h4 class=" font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">Grade</h4></div>
            <div class="margin-bottom-10px"><h4 class="margin-bottom-0px display-inline" *ngIf="Grade1">{{Grade1}}</h4><h4 class="margin-bottom-0px display-inline" *ngIf="Grade2">{{Grade2}}</h4> </div>
          </div>
          <div class="col-md-3 text-align-center padding-right-0px padding-left-0px border-right-1px">
            <div class="margin-top-10"><h4 class=" font-weight-bold margin-bottom-0px label-color-consultant font-size-12px">EmbryoCount</h4></div>
            <div class="margin-bottom-10px"><h4 class="margin-bottom-0px" *ngIf="Embryocount">{{Embryocount}}</h4></div>
          </div>
        </div>-->
        <div class="row margin-left-0px margin-right-0px">
          <div class="col-md-12">
            <div class="table-component margin-bottom-0px">
              <div class="table-responsive">


                <table class="table table-striped margin-left-zero width-100pe">

                  <thead class="">
                    <tr>
                      <!--<th class="min-width-0px padding-right-0px padding-left-0px"></th>-->
                      <th class="padding-top-4px padding-bottom-4px font-size-12px min-width-0px">Sno</th>
                      <th class="padding-top-4px padding-bottom-4px font-size-12px white-space-preline">Cycle Details </th>
                      <th class="padding-top-4px padding-bottom-4px font-size-12px  padding-left-0px">DOC</th>

                      <th class="padding-top-4px padding-bottom-4px font-size-12px  padding-left-0px padding-right-0px">Date</th>
                      <th class="white-space-preline padding-top-4px padding-bottom-4px font-size-12px">Grade</th>
                      <th class="white-space-preline padding-top-4px padding-bottom-4px font-size-12px">Stage</th>
                      <th class="white-space-preline padding-top-4px padding-bottom-4px font-size-12px">Can Freeze Count</th>
                      <th class="white-space-preline padding-top-4px padding-bottom-4px font-size-12px">Freeze Count</th>


                      <!--<th class="min-width-0px padding-top-4px padding-bottom-4px font-size-12px white-space-preline">Available Count</th>-->
                      <!--<th class="padding-top-4px padding-bottom-4px font-size-12px white-space-preline">Available Count</th>-->
                      <!--<th class="padding-top-4px padding-bottom-4px font-size-12px">Storage</th>-->


                    </tr>
                  </thead>
                  <tbody class="table-body">

                    <tr *ngFor="let l of SelectedGrades ; let RowIndex = index ">
                      <!--<td class="padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px"> <input type="checkbox" class="width-15px "></td>-->
                      <td class="padding-top-4px padding-bottom-4px">{{RowIndex+1}}</td>
                      <td class="padding-top-4px padding-bottom-4px"></td>
                      <td class="padding-top-4px padding-bottom-4px padding-right-0px padding-left-0px text-align-center">
                        {{l.DOC}}

                      </td>
                      <td class="padding-top-4px padding-bottom-4px padding-right-0px padding-left-0px">

                        {{l.CreatedTimeStamp| date:'MMM-dd-yyyy'}}
                      </td>
                      <td class="padding-top-4px padding-bottom-4px"><label class="margin-bottom-0px margin-left-10px">{{l.Grade1}}</label><label *ngIf="l.DOC!=='4'">{{l.Grade2}} </label></td>

                      <td class="padding-top-4px padding-bottom-4px padding-left-15px">{{l.CellStage}}</td>
                      <!--<td class="padding-top-4px padding-bottom-4px text-align-center"> {{l.FrozenCount}}</td>-->
                      <td class="padding-top-4px padding-bottom-4px text-align-center">{{l.AvailableCount}}</td>
                      <td class="padding-top-4px padding-bottom-4px text-align-center"> {{l.SelectedFreezeCount}}</td>
                      <!--<td class="padding-top-4px padding-bottom-4px text-align-center">{{l.AvailableCount}}</td>-->
                      <!--<td class="padding-top-4px padding-bottom-4px">
                        <input type="checkbox" class="width-30px height-14px margin-top-3px display-inline" (click)="Selectedrow(l)"
                               [(ngModel)]="l.IsSelected" />
                        <i class="input-helper"></i>

                        <input type="number" class="form-control-patient width-34pe display-inline" placeholder=""
                               [(ngModel)]="Frozennumber"
                               name="Frozennumber" #Frozen="ngModel"
                               maxlength="100" required *ngIf="l.IsSelected">

                      </td>-->
                    </tr>
                  </tbody>

                </table>

              </div>
            </div>
          </div>
        </div>


        <div class="row margin-left-zero margin-right-0px">
          <div class="card col-md-12">
            <div class="card-header wh-header padding-top-6px padding-bottom-6px">
              <div class="row background-bordercolor padding-all-5px">
                <div class="col-md-8">
                  <h4 class="margin-bottom-0px font-size-15px font-weight-bold margin-top-7px">Select Storage Location</h4>
                </div>
                <div class="col-md-4 text-align-right">
                  <div class="row">
                    <div class="col-md-9 padding-right-0px font-size-15px margin-top-3px">
                      Total Number :
                    </div>
                    <div class="col-md-1 padding-left-6px">
                      <a *ngIf="TotalValue2"><div class="badge badge-search padding-top-3px padding-bottom-3px"><h4 class="margin-bottom-4px margin-top-4px">{{TotalValue2}}</h4></div></a>
                    </div>
                  </div>

                </div>
              </div>

            </div>
            <form class="form margin-bottom-5px" (ngSubmit)="onSubmit2()" novalidate="" #f="ngForm">
              <div class="card-body padding-all-0px margin-left-zero">
                <div class="row margin-left-0px margin-right-0px">
                  <div class="col-md-6 offset-md-1">
                    <div class="row">
                      <div class="form-group col-md-10 col-xs-12 margin-bottom-5px">
                        <div class="row">
                          <div class="col-md-5 text-align-right">
                            <label for="diaplayName" class="margin-bottom-0px margin-top-3px"> Cryo Top Color</label>
                          </div>

                          <div class="col-md-5">
                            <CodeTypeValue CodeType="CRCLR" id="CurrentSaveEmbryoStorageAreaInfoRequest2.CryoTopColor"
                                           [(ngModel)]="CurrentSaveEmbryoStorageAreaInfoRequest2.CryoTopColor" SelectedValue="CurrentSaveEmbryoStorageAreaInfoRequest2.CryoTopColor"
                                           name="CurrentSaveEmbryoStorageAreaInfoRequest2.CryoTopColor">
                            </CodeTypeValue>
                            <!--<input type="text" class="form-control" placeholder="Relation Name" />-->
                            <!--id="CurrentActorEditEmergencyInfoRequest.RelationType"
                                   [(ngModel)]="CurrentActorEditEmergencyInfoRequest.RelationType"
                                   name="CurrentActorEditEmergencyInfoRequest.RelationType"
                                    maxlength="20" minlength="1" #RelationType="ngModel" pattern="^[\sa-zA-Z0-9,/._\-?]*$">
                            <small class="form-text text-danger"
                                   *ngIf="(!RelationType.valid && (RelationType.dirty || RelationType.touched) && RelationType.errors.required)">(Field cannot be left blank)</small>
                            <small class="form-text text-danger"
                                   *ngIf="(!RelationType.valid && RelationType.errors.pattern)">(special characters are not allowed)</small>-->

                          </div>
                        </div>


                      </div>
                    </div>
                    <div class="row">
                      <div class="form-group col-md-10 col-xs-12 margin-bottom-5px">
                        <div class="row">
                          <div class="col-md-5 text-align-right">
                            <label for="firstName" class="margin-bottom-0px margin-top-3px"> Cannister No</label>
                          </div>
                          <div class="col-md-5">

                            <CodeTypeValue CodeType="CNSTR"
                                           id="CurrentSaveEmbryoStorageAreaInfoRequest2.CanisterNo"
                                           [(ngModel)]="CurrentSaveEmbryoStorageAreaInfoRequest2.CanisterNo" SelectedValue="CurrentSaveEmbryoStorageAreaInfoRequest2.CanisterNo"
                                           name="CurrentSaveEmbryoStorageAreaInfoRequest2.CanisterNo">
                            </CodeTypeValue>

                          </div>

                        </div>

                      </div>
                    </div>
                    <div class="row">
                      <div class="form-group col-md-10 col-xs-12 margin-bottom-5px">
                        <div class="row">
                          <div class="col-md-5 text-align-right padding-left-0px">
                            <label for="diaplayName" class="margin-bottom-0px margin-top-3px"> Goblet</label>
                          </div>
                          <div class="col-md-5">
                            <CodeTypeValue CodeType="GBCLR"
                                           id="CurrentSaveEmbryoStorageAreaInfoRequest2.Goblet"
                                           [(ngModel)]="CurrentSaveEmbryoStorageAreaInfoRequest2.Goblet" SelectedValue="CurrentSaveEmbryoStorageAreaInfoRequest2.Goblet"
                                           name="CurrentSaveEmbryoStorageAreaInfoRequest2.Goblet">
                            </CodeTypeValue>
                          </div>
                        </div>


                      </div>
                    </div>
                    <div class="row">
                      <div class="form-group col-md-10 col-xs-12 margin-bottom-5px">
                        <div class="row">
                          <div class="col-md-5 text-align-right ">
                            <label for="diaplayName" class="margin-bottom-0px margin-top-3px">Hexa </label>
                          </div>
                          <div class="col-md-5">
                            <!--<CodeTypeValue CodeType="MARTL"></CodeTypeValue>-->
                            <!--id="CurrentActorPersonalDetailInfoRequest.City"
                                   [(ngModel)]="CurrentActorPersonalDetailInfoRequest.City"
                                   name="CurrentActorPersonalDetailInfoRequest.City"
                                    maxlength="50" pattern="^[\sa-zA-Z0-9,._\-?]*$" #City="ngModel" />
                            <small class="form-text text-danger"
                                   *ngIf="(!City.valid && City.errors.pattern)">(special characters are not allowed)</small>-->
                            <!--<label>Hyderabad</label>-->
                            <CodeTypeValue CodeType="HXCLR"
                                           id="CurrentSaveEmbryoStorageAreaInfoRequest2.Hexa"
                                           [(ngModel)]="CurrentSaveEmbryoStorageAreaInfoRequest2.Hexa" SelectedValue="CurrentSaveEmbryoStorageAreaInfoRequest2.Hexa"
                                           name="CurrentSaveEmbryoStorageAreaInfoRequest2.Hexa">
                            </CodeTypeValue>
                          </div>
                        </div>


                      </div>
                    </div>
                    <div class="row">
                      <div class="form-group col-md-10 col-xs-12 margin-bottom-5px">
                        <div class="row">
                          <div class="col-md-5 text-align-right ">
                            <label for="diaplayName" class="margin-bottom-0px margin-top-3px">Viso </label>
                          </div>
                          <div class="col-md-5 ">
                            <!--<CodeTypeValue CodeType="MARTL"></CodeTypeValue>-->
                            <!--id="CurrentActorPersonalDetailInfoRequest.City"
                                   [(ngModel)]="CurrentActorPersonalDetailInfoRequest.City"
                                   name="CurrentActorPersonalDetailInfoRequest.City"
                                    maxlength="50" pattern="^[\sa-zA-Z0-9,._\-?]*$" #City="ngModel" />
                            <small class="form-text text-danger"
                                   *ngIf="(!City.valid && City.errors.pattern)">(special characters are not allowed)</small>-->
                            <!--<label>Hyderabad</label>-->
                            <CodeTypeValue CodeType="VSCLR"
                                           id="CurrentSaveEmbryoStorageAreaInfoRequest2.Viso"
                                           [(ngModel)]="CurrentSaveEmbryoStorageAreaInfoRequest2.Viso" SelectedValue="CurrentSaveEmbryoStorageAreaInfoRequest2.Viso"
                                           name="CurrentSaveEmbryoStorageAreaInfoRequest2.Viso">
                            </CodeTypeValue>
                          </div>
                        </div>


                      </div>
                    </div>

                    <!--<div class="row">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                        <div class="row">
                          <div class="col-md-3 text-align-right ">
                            <label for="diaplayName" class="margin-bottom-0px margin-top-3px">Count </label>
                          </div>
                          <div class="col-md-4 ">
                            <input type="text" class="form-control" placeholder="Count"
                                   id="CurrentEditEmbryoStorageAreaInfoRequest.StoreEmbryoCount"
                                   [(ngModel)]="CurrentEditEmbryoStorageAreaInfoRequest.StoreEmbryoCount"
                                   name="CurrentEditEmbryoStorageAreaInfoRequest.StoreEmbryoCount" #Endometrium="ngModel"
                                   maxlength="5" pattern="^[\0-9,._\-?]*$" required>
                            <small class="form-text text-danger"
                                   *ngIf="(!Endometrium.valid && (Endometrium.dirty || Endometrium.touched) && Endometrium.errors.required )">(Field cannot be left blank)</small>
                            <small class="form-text text-danger"
                                   *ngIf="(!Endometrium.valid && Endometrium.errors.pattern)">(only numbers are allowed)</small>
                          </div>

                        </div>


                      </div>
                    </div>-->
                  </div>
                  <div class="col-md-5">
                    <div class="row background-embryo margin-left-0px margin-right-0px">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                        <div class="row">
                          <div class="col-md-6">
                            <label for="firstName" class="margin-bottom-0px margin-top-5px font-size-24px">Straw No :</label>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-9">

                            <CodeTypeValue CodeType="STNO" id="CurrentSaveEmbryoStorageAreaInfoRequest2.StrawNumber" class="Strawfont"
                                           [(ngModel)]="CurrentSaveEmbryoStorageAreaInfoRequest2.StrawNumber" SelectedValue=""
                                           name="CurrentSaveEmbryoStorageAreaInfoRequest2.StrawNumber" required>

                            </CodeTypeValue>
                            <!--<input type="text" class="form-control" placeholder="Test"
                                   id="CurrentSaveIvfCycleMedicineDataRequest.Form"
                                   [(ngModel)]="CurrentSaveIvfCycleMedicineDataRequest.Form"
                                   name="CurrentSaveIvfCycleMedicineDataRequest.Form" #Doctor="ngModel"
                                   maxlength="100" required>
                            <small class="form-text text-danger"
                                   *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                            <small class="form-text text-danger"
                                   *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->
                            <!--<CustomDataByRequestType RequestedType="FacilitiesByActor" ActorCode={{ActorCode}}
                                                     id="CurrentSaveIvfCycleMedicineDataRequest.Form" SelectedValue=""
                                                     [(ngModel)]="CurrentSaveIvfCycleMedicineDataRequest.Form" (keyChange)="onAssignedToActorCode($event)"
                                                     name="CurrentSaveIvfCycleMedicineDataRequest.Form" required>
                            </CustomDataByRequestType>-->
                          </div>



                        </div>

                      </div>
                    </div>
                  </div>

                </div>

              </div>
              <div class="card-footer padding-top-6px padding-bottom-6px">
                <button type="submit" class="btn actions-btn-prime float-right font-size-13px margin-right-auto margin-left-3px" *ngIf="Length>0">Save</button>
                <button type="button" class="btn btn-secondary btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-left-auto font-size-13px float-right margin-left-3px" (click)="activeModal.dismiss('Cross click')">Cancel</button>



              </div>
            </form>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
